import { csx } from '@vtex/admin-ui'

const styles = {
  operator: csx({ width: 'full' }),

  content: csx({
    rowGap: '$space-5',
  }),

  expression: csx({ columnGap: '$space-3', width: 'full' }),

  input: csx({ flex: 1 }),

  removeButton: csx({
    '&&': {
      height: 'auto',
      padding: '$space-3',
    },
  }),

  addButton: csx({ '&&': { height: 'auto', padding: '$space-3' } }),
}

export default styles
